/** @jsx isolateComponent */

import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Typography } from '../../../theme/Typography';
import type { IconName } from '../../display/Icon';

import { ArticleLink } from '../ArticleLink';

export type Props = {
  /** The route to the thing that is being linked to. */
  href: string;
  /** The name of the icon to display. */
  icon: IconName;
  /** The title of the thing that is being linked to. */
  title: string;
  /** Some metadata about the link. */
  metaInfo: string;
  /** Some additional metadata about the link. */
  additionalMetaInfo?: string;
};

const Styles = labelStyles('FeaturedArticleLink', {
  footer: {
    ...Typography.altText800,
    '> *:not(:last-child)::after': {
      content: '" • "',
    },
  },
  metaInfo: {
    fontWeight: 600,
  },
});

/**
 * Renders a featured article link, which includes more context than an article
 * link.
 */
export const FeaturedArticleLink: React.FC<Props> = (props) => {
  return (
    <ArticleLink {...props} size="large">
      <footer css={Styles.footer}>
        <span
          aria-label={`Info about this link: ${props.metaInfo}`}
          css={Styles.metaInfo}
        >
          {props.metaInfo}
        </span>
        {props.additionalMetaInfo && (
          <span
            aria-label={`Additional info about this link: ${props.additionalMetaInfo}`}
          >
            {props.additionalMetaInfo}
          </span>
        )}
      </footer>
    </ArticleLink>
  );
};
